export const SuccessCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0002 24.0004C18.6277 24.0004 24.0004 18.6277 24.0004 12.0002C24.0004 5.37267 18.6277 0 12.0002 0C5.37267 0 0 5.37267 0 12.0002C0 18.6277 5.37267 24.0004 12.0002 24.0004ZM17.2862 9.78471C17.67 9.40094 17.67 8.77874 17.2862 8.39497C16.9025 8.0112 16.2803 8.0112 15.8965 8.39497L10.0038 14.2877L7.23033 11.5142C6.84657 11.1304 6.22436 11.1304 5.84059 11.5142C5.45683 11.898 5.45683 12.5202 5.84059 12.9039L9.30893 16.3723C9.6927 16.756 10.3149 16.756 10.6987 16.3723L17.2862 9.78471Z'
        fill='currentColor'
      />
    </svg>
  )
}
